/* eslint-disable react-hooks/exhaustive-deps */
import { AppBar, Button, Container, Toolbar, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ICONS from "../../../assets/Icons";
import { setCurrentMenu } from "../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import {
  setMultipleEntity,
  setShowReloginModalFalse,
} from "../../../redux/features/login/login";
import {
  xpentraLogout,
  xpentraLogoutSliceReset,
} from "../../../redux/features/logout/logout";
import { logout } from "../../../redux/features/refreshToken/refreshToken";

const ResponsiveAppBarLogout = ({ slideCard }) => {
  const isCalendarOpen = useSelector((state) => state.holidays?.isCalendarOpen);

  const appBarRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const { xpentraLogoutLoading, xpentraLogoutData, xpentraLogoutError } =
    useSelector((state) => state?.xpentraLogoutSlice);

  useEffect(() => {
    if (!xpentraLogoutLoading && xpentraLogoutData?.status) {
      dispatch(setMultipleEntity());
      dispatch(setShowReloginModalFalse());
      dispatch(logout());
      dispatch(xpentraLogoutSliceReset());
      navigate("/login");
      sessionStorage.clear();
    } else if (
      !xpentraLogoutLoading &&
      !xpentraLogoutData &&
      xpentraLogoutError?.isErrorStatus
    ) {
      dispatch(xpentraLogoutSliceReset());
    }
  }, [xpentraLogoutLoading, xpentraLogoutData, xpentraLogoutError]);

  const [showAppBar, setShowAppBar] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      const isViewAllPage = location.pathname === "/multi_entity_viewAll";
      setShowAppBar(window.innerWidth > 1024 || !isViewAllPage);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className={`w-full ${
        slideCard ? "responsivAppBarUpAnimate" : "responsivAppBarAnimate"
      }
      `}
      style={{
        transition: "all 0.4s linear",
        position: "fixed",
        top: "0",
        left: "0",
        zIndex: "9999",
      }}
    >
      <AppBar
        ref={appBarRef}
        style={{
          background: "var(--Nav-background)",
          height: "var(--navbar-height)",
          borderBottomLeftRadius: "var(--border-radius-md)",
          borderBottomRightRadius: "var(--border-radius-md)",
          zIndex: isCalendarOpen ? "9999" : "",
          display: showAppBar ? "flex" : "none",
        }}
      >
        <Container
          className="mx-auto"
          sx={{
            maxWidth: "var(--std-width)",
            display: "flex !important",
            justifyContent: "space-between !important",
            alignItems: "center",
          }}
        >
          <Toolbar disableGutters>
            <Typography
              variant="h6"
              marginLeft="var(--bottom-sm)"
              component="a"
              onClick={() => {
                navigate("/home");
                dispatch(setCurrentMenu("Home"));
              }}
            >
              <img
                className="cursor-pointer w-xpentra-logo-width h-xpentra-logo-height "
                src={ICONS?.XPENTRA_BLUE}
                alt="XpentraLogo"
              />
            </Typography>
          </Toolbar>
          <Button
            variant="outlined"
            style={{
              borderColor: "var(--Verification-failed)",
              padding: "var(--padding-button-m) var(--padding-button-l)",
              fontSize: "var(--font-xs)",
              fontWeight: "regular",
              color: "var(--Verification-failed)",
              textTransform: "capitalize",
              fontFamily: "Open Sans",
            }}
            onClick={() => {
              dispatch(xpentraLogout());
              sessionStorage.removeItem("conciergeLogin");
            }}
          >
            Logout
          </Button>
        </Container>
      </AppBar>
    </div>
  );
};

export default ResponsiveAppBarLogout;
